var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappCircleOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5142",
    "data-name": "Rectangle 5142",
    width: 22.958,
    height: 22.946,
    fill: "#33cc34"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13337",
    "data-name": "Group 13337",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11966",
    "data-name": "Group 11966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.375,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13241",
    "data-name": "Group 13241",
    transform: "translate(6.783 6.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13240",
    "data-name": "Group 13240",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45465",
    "data-name": "Path 45465",
    d: "M12.34,22.946H10.592L9.1,22.708a11.846,11.846,0,0,1-3.92-1.633L.774,22.453l1.389-4.234A13.073,13.073,0,0,1,.338,14.257L.011,12.32c.025-.559-.034-1.148,0-1.7C.614.849,12.871-3.618,19.739,3.464c6.753,6.964,2.21,18.888-7.4,19.482m1.374-8.355c-.384.33-.736.146-1.136-.022a9.051,9.051,0,0,1-3.791-3.159,3.518,3.518,0,0,1-.526-.912c-.039-.4.681-.937.914-1.275A.82.82,0,0,0,9.339,8.4a19.447,19.447,0,0,0-1.04-2.5c-.133-.272-.221-.555-.558-.608C5.614,4.954,4.677,7.12,4.859,8.93c.217,2.159,3.025,5.348,4.707,6.636a12.685,12.685,0,0,0,4.6,2.166c1.907.429,4.094-.372,4.223-2.565.016-.276.048-.535-.192-.7A18.172,18.172,0,0,0,15.823,13.3a2.043,2.043,0,0,0-.681-.22c-.544,0-1.023,1.165-1.427,1.513",
    transform: "translate(0 0)",
    fill: "#33cc34"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappCircleOrange);
export default __webpack_public_path__ + "static/media/whatsapp-circle-orange.c5f19aa5e0c87e618de8a98b7bcf6186.svg";
export { ForwardRef as ReactComponent };